import { createAction, props } from "@ngrx/store";

export const setPermissions = createAction('[Permissions] Set Permissions', props<{ permissions: Record<string, any>, permissionScope: 'user' | 'organisation' }>());
export const setRole = createAction('[Permissions] Set Role', props<{ role: string }>());